'use strict';

angular.module('directives.icheck', [])

.directive('icheck', ['$timeout', '$parse', function ($timeout, $parse) {
    return {
        compile: function (element, $attrs) {
            var icheckOptions = {
                checkboxClass: 'icheckbox_flat-grey',
                radioClass: 'iradio_flat-grey'
            };

            var modelAccessor = $parse($attrs['ngModel']);
            return function ($scope, element, $attrs, controller) {

                var modelChanged = function (event) {
                    $scope.$apply(function () {
                        modelAccessor.assign($scope, event.target.checked);

                        if (event.target.checked) {
                            $scope.$eval($attrs.whenChecked);
                        }
                        else {
                            $scope.$eval($attrs.whenUnchecked);
                        }
                    });
                };

                $scope.$watch(modelAccessor, function (val) {
                    var action = val ? 'check' : 'uncheck';
                    element.iCheck(icheckOptions, action).on('ifChanged', modelChanged);
                });
            };
        }
    };
}]);
